import React from 'react'

const React_Assignment_3 = () => {
  return (
    <div>
      <h1>Assignment 3</h1>
    </div>
  )
}

export default React_Assignment_3
